import { ReactElement } from 'react'
import { Alert, Box } from '@mui/material'

/**
 * Shown in place of a metadata-dependent IFC Import tool (filter, type/storey assignment) while the
 * IFC metadata is still being read in the background job after upload. Prevents interacting with —
 * and accidentally writing to — the model_metadata field before it has been computed.
 */
const IFCMetadataPendingNotice = (): ReactElement => (
  <Box sx={{ p: 1 }}>
    <Alert severity="info" data-cy="ifc-metadata-pending">
      Die IFC-Metadaten werden noch eingelesen. Sobald sie bereitstehen, können die Elemente
      gefiltert und zugewiesen werden.
    </Alert>
  </Box>
)

export default IFCMetadataPendingNotice
